<template>
  <header v-bind="attrs">
    <div 
      class="n-header__container container"
      v-click-outside="outside">
      
      <!-- First -->
      <div class="n-header__group n-header__first">
        <!-- Burger -->
        <div class="n-header__item">
          <button
            ref="burgercta"
            class="n-header__button n-header__burger-cta"
            @click="showBurger">
            <span class="n-header__button-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>

      <!-- Second -->
      <div class="n-header__group n-header__second">
        <router-link :to="{ name: 'sayl-oat-catalog.catalog' }">
          <img 
            :src="logo" 
            alt="" 
            class="n-header__logo">
        </router-link>
      </div>

      <!-- Third -->
      <div class="n-header__group n-header__third">
        <button 
          class="n-header__button n-header__item-locale locale"
          @click="showLocales = true">
          <ui-icon class="locale__icon" glyph="globe" />
          <span class="locale__label">{{ userLang }}</span>
        </button>

        <router-link
          :to="{ name: 'sayl-oat-checkout.cart' }"
          class="n-header__button n-header__bag"
          @click="showBurger">
          <checkout-cart-badge />
        </router-link>
      </div>
    </div>

    <!-- Popin Locales -->
    <popins-modal
    :closable="true"
    :klass="{ 'n-header__locales': true }"
    :visible="showLocales"
    position="top-center"
    @close="showLocales = false"
    >
    <!-- v-on="$listeners"
    @close="close" -->
    
      <ul class="locales__list">
        <li 
          v-for="lang in langs"
          :key="lang.value"
          :class="{ 'locales__item': true, '-is-active': lang.value === userLang }">
          <button class="locales__locale" @click="onChangeLang(lang.value)">{{ lang.label }}</button>
        </li>
      </ul>

    </popins-modal>
  </header>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { ClickOutside } from '@spices/pepper'
import CheckoutCartBadge from '@/components/checkout/cart-badge'

export default {
  name: 'NavigationsHeader',

  components:{
    CheckoutCartBadge
  },

  directives: {
    ClickOutside
  },

  data(){
    return {
      outside: {
        handler: this.onClickOutside,
        middleware: this.clickOutsideMiddleware
      },

      showLocales: false
    }
  },

  computed:{
    ...mapState({
      burger: state => state.bootstrap.burger,
      cart: state => state['sayl-oat'].cart,
      locales: state => state.bootstrap.i18n.locales,
      i18n: state => state.bootstrap.i18n,
      shop: state => state['sayl-oat'].shop,
      tables: state => state['sayl-oat'].tables,
      user: state => state['sayl-oat.user'].user,
    }),

    attrs(){
      return {
        class: this.classes,
      }
    },

    classes(){
      return {
        'n-header': true,
        '-is-active': !this.burger
      }
    },

    langs() {
      return this.locales.map((l) => {
        return {
          label: this.$t(`sayl-oat.lang_${l.toISO3166().toLowerCase()}`), 
          value: l.toISO639()
        } 
      });
    },

    logo(){
      return this.shop && this.shop.logo ? this.shop.logo : null;
    },

    nCartItem(){
      return this.cart ? this.cart.items.length : 0;
    },
    
    tableNumber(){
      let ret = '';
      const t = this.tables.find(t => t.id === this.cart.tableNumber);

      if(t) {
        ret = t.name || ''
      }

      return ret;
    },

    userLang() {
      return this.user !== null ? this.user.lang : this.shop.primary_language;
    },
  },

  methods:{
    ...mapActions({
      changeLang: 'sayl-oat.user/changeLang'
    }), 

    showBurger(){
      this.$store.dispatch('bootstrap/burger', true);
    },

    clickOutsideMiddleware(event){
      return true;
    },

    onChangeLang(value) {
      this.showLocales = false;
      const lang = this.locales.find(l => {
        return l.toISO639() === value;
      });
      this.changeLang(lang.toISO3166()).then(() => { 
        this.i18n.setLocale(lang.toISO3166());
      });
    },

    onClickOutside (event) {
      this.showFavorites = false;
      this.showRecent = false;
      this.showUser = false;
    },
  }
}
</script>
